import Vue from "vue";

export default {
  verifyCompany(context, company_id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post("/auth/company/verify", { company_id })
        .then(response => {
          Vue.$user.setCompany(response.data);
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  verifyPayment(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post("/auth/company/subscription", payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  signin({ dispatch }, { username, password }) {
    return new Promise((resolve, reject) => {
      const params = {
        client_id: Vue.$config.get("VUE_APP_API_CLIENT_ID"),
        client_secret: Vue.$config.get("VUE_APP_API_CLIENT_SECRET"),
        grant_type: Vue.$config.get("VUE_APP_API_GRANT_TYPE"),
        username,
        password,
        company_id: Vue.$user.getCompany().slug,
      };

      Vue.$http
        .post("/auth/login", params)
        .then(response => {
          const token = {
            access_token: response.access_token,
            expires_in: response.expires_in,
            refresh_token: response.refresh_token,
            token_type: response.token_type,
          };

          Vue.$user.setToken(token);
          Vue.$http.defaults.headers["Authorization"] = `Bearer ${
            response.access_token
          }`;

          dispatch("getUser")
            .then(response => {
              Vue.$http.defaults.headers[
                "active-branch"
              ] = Vue.$user.getActiveBranch();
              resolve(response);
            })
            .catch(error => reject(error));
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  signup(_, params) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post("/auth/signup", params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  getIndustries() {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get("/industries")
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  resendActivationEmail(_, params) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post("auth/resend-activation-email", params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  getUser() {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get("/user", {
          headers: {
            Authorization: `Bearer ${Vue.$user.getToken().access_token}`,
          },
        })
        .then(response => {
          Vue.$user.set(response.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  forgotPassword(context, params) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post("/auth/forgot-password", params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  resetPassword(context, params) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post("/auth/reset-password", params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  accountActivation(context, params) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post("/auth/user-confirmation", params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  changPasswordOnFirstSignin(context, new_password) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post("/user/change-password-on-first-signin", { new_password })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  changePassword(context, params) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post("/user/change-password", params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
};
